const navigation = [
  {
    name: "Home",
    id: "home",
    path: "/",
    translationKey: "header.home",
  },
  {
    name: "Subjects",
    id: "subjects",
    path: "/",
    translationKey: "header.subjects",
  },
  // {
  //   name: "About Us",
  //   id: "about-us",
  //   path: "/about-us",
  //   translationKey: "header.aboutUs",
  // },
  // {
  //   name: "Right to Information",
  //   id: "right-to-information",
  //   path: "/right-to-information",
  //   translationKey: "header.rightToInformation",
  // },
  {
    name: "Laws and Regulation",
    id: "laws-and-regulation",
    path: "/laws-and-regulation",
    translationKey: "header.lawsAndRegulation",
  },
  {
    name: "FAQs",
    id: "faqs",
    path: "/faqs",
    translationKey: "header.faqs",
  },
];
export default navigation;